export default __webpack_public_path__ + "static/media/emoji_friends.b99240ff.svg";